// extracted by mini-css-extract-plugin
export default {"tabsNav":"tabs_tabsNav__zrN2S","tab":"tabs_tab__2zjom","tabActive":"tabs_tabActive__enVxa"};